module.exports = __webpack_public_path__ + "img/196.problem_urinals.5b67cb67.svg";